<template>
  <el-dialog
    title="Table Columns Visibility"
    top="5vh"
    visible
    :fullscreen="isFullscreen"
    @close="$emit('update:isShow', false)"
  >
    <el-form
      ref="visibilityForm"
      :model="value"
    >
      <el-row>
        <el-col :md="24">
          <el-form-item
            v-for="(key, index) in Object.keys(value)"
            :key="index"
            :label="formatLabel(key)"
          >
            <el-switch v-model="value[key]" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        @click.native="$emit('update:isShow', false)"
      >
        Apply
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { titleize } from 'inflected'
export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    isShow: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isFullscreen: false
    }
  },
  methods: {
    formatLabel (key) {
      return titleize(key)
    }
  }
}
</script>

<style>

</style>
